<template>
      <div class="upload-con">
        <el-upload :show-file-list="false" :on-success="handleAvatarSuccess" :before-upload="beforeAvatarUpload" :http-request="fileUpdate" action="">
            <img v-if="imageUrl" :src="imageUrl" class="avatar" />
            <div class="avatar-uploader-icon" v-else>
                <i class="el-icon-camera "></i>
            </div>
        </el-upload>
        <p>请添加频道图标,JPEG/PNG/SVG格式,1M以内</p>
    </div>
</template>

<script>
import { upload } from "@/network/content/channel.js";
import {  baseImg } from "@/common/global.js";
export default {
    name: "",
    props: {
        // 弹框宽度
        operForm: {
            type: Object,
            default: function () {
                return {};
            },
        },
    },
    data() {
        return {
            files: null,
            imageUrl: this.operForm.img
                ? baseImg + this.operForm.img
                : "",
        };
    },
    methods: {
        beforeAvatarUpload() { },
        handleAvatarSuccess() { },
        // 存取文件
        async fileUpdate(param) {
            this.files = param.file;
            const form = new FormData();
            form.append("file", this.files);
            try {
                let res = await upload(form);
                if (res.data.code == 200) {
                    this.$message.success("上传成功");
                    this.imageUrl = baseImg + res.data.data;
                    this.operForm.img = res.data.data;
                } else {
                    this.$message.error(res.data.msg);
                }
            } catch (error) {
                this.$message.error("上传失败");
            }
        },
    },
    created() { },
};
</script>

<style lang="scss" >
.upload-con {
    display: flex;
    width: 100%;
    p {
        padding: 0 20px;
        height: 80px;
        line-height: 80px;
        color: #8c939d;
    }
}
.el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
}
.el-upload:hover {
    border-color: #409eff;
}
.avatar-uploader-icon {
    font-size: 26px;
    color: #8c939d;
    width: 80px;
    height: 80px;
    line-height: 80px;
}
.avatar {
    width: 100px;
    height: 100px;
    display: block;
}
</style>
